import { Feedback, SurveyAnswers } from "../models/users/ChatUser";
import { IChatVisual } from "../models/users/ChatVisual";
import { UserPrompt } from "../models/users/UsersState";
import { UserService } from "../services/UserService";
import { CompanyInfo } from "../models/company/Company";


export const useUser = () => {
    const userService = new UserService();

    const getChatVisual = async (): Promise<IChatVisual| null> => {
        try {
          if(window.electron?.isElectron){
            const result = await userService.getChatVisual();
            return result;
          }
          const { latitude, longitude } = await getCurrentPosition();
          const result = await userService.getChatVisual(latitude, longitude);
          return result;
        } catch (error) {
          console.error(error);
          const result = await userService.getChatVisual();
          return result; // 적절한 에러 처리나 기본값 반환
        }
      };

    const getCurrentPosition = (): Promise<GeolocationCoordinates> => {
        return new Promise((resolve, reject) => {
          navigator.geolocation.getCurrentPosition(
            (position) => {
              resolve(position.coords);
            },
            (error) => {
              reject(new Error(error.message));
            },
          );
        });
      };

    const getUserPrompt = async () : Promise<UserPrompt> => {
        const result = await userService.getUserPrompt();
        return result;
    }

    const checkUserPrompt = async () : Promise<boolean> => {
      const result = await userService.checkUserPrompt();
      return result;
  }
    
    const updateUserPrompt = async (prompt: UserPrompt) : Promise<boolean> => {
        const result = await userService.updateUserPrompt(prompt);
        return result;
    }

    const insertFeedback = async (feedback: Feedback, answers: SurveyAnswers | null) : Promise<boolean> => {
      try{
        await userService.insertFeedback(feedback);
        if(answers) await userService.insertSurvey(answers);

        return true;
      }catch{
        return false;
      }
      
    }

    const getSurvey = async (index: string) : Promise<boolean> => {
      return await userService.getSurvey(index);
    }

    const getGuideShouldShow = async (key: string) : Promise<boolean> => {
      return await userService.getGuideShouldShow(key);
    }

    const setGuideSeen = async (key: string) : Promise<boolean> => {
      return await userService.setGuideSeen(key);
    }

    const getCompanyInfo = async () : Promise<CompanyInfo> => {
      return await userService.getCompanyInfo();
    }

    return {
        getChatVisual,
        getUserPrompt,
        updateUserPrompt,
        checkUserPrompt,
        insertFeedback,
        getSurvey,
        getGuideShouldShow,
        setGuideSeen,
        getCompanyInfo
    };
}